

  
 <div class="tab-container">        
<mat-tab-group>
  
  <mat-tab label=" {{'UNDERCARRIAGE' | translate | async}}">
    <div class="alerts-container">

  <table class="alerts-table">

    <thead>
      <tr>
        <th>{{'Alert Name' | translate | async}}</th>
        <th>{{'Description' | translate | async}}</th>
        <th>{{'Frequency' | translate | async}}</th>
        <th>{{'Enabled' | translate | async}}</th>
         <th>{{'Email Enabled' | translate | async}}</th>
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let alert of AlertVM?.Data">

        <td>
          {{ alert.AlertName }}
        </td>

        <td>
          {{ alert.AlertDescription }}
          <button mat-icon-button *ngIf="alert.HasSetting" matTooltip="Alert Settings" (click)="openSettings(alert)" class="settings-btn"> 
            <mat-icon>settings</mat-icon>
        </button>
        </td>

        <td>
            {{ alert.AlertFrequency }}
        </td>

       <!-- MAIN ENABLE TOGGLE -->
      <td class="text-center">
        <mat-slide-toggle  [(ngModel)]="alert.IsEnabled" (change)="onToggleChange(alert)"> </mat-slide-toggle>
      </td>

      <!-- EMAIL ENABLE TOGGLE  [disabled]="!alert.IsEnabled"-->
      <td class="text-center">
        <mat-slide-toggle [(ngModel)]="alert.IsEmailEnabled" [disabled]="true"   (change)="onEmailToggle(alert)"> </mat-slide-toggle>
      </td>
      </tr>
    </tbody>
  </table>

</div>
  </mat-tab>

  <mat-tab label="GET">
    <table class="alerts-table">
    <thead>
      <tr>
        <th>{{'Alert Name' | translate | async}}</th>
        <th>{{'Description' | translate | async}}</th>
        <th>{{'Frequency' | translate | async}}</th>
        <th>{{'Enabled' | translate | async}}</th>
         <th>{{'Email Enabled' | translate | async}}</th>
      </tr>
    </thead>

    <tbody>
      <tr>

        <td>
          
        </td>

        <td>
          
        </td>

        <td>
          
        </td>

       <!-- MAIN ENABLE TOGGLE -->
      <td class="text-center">
       
      </td>

      <!-- EMAIL ENABLE TOGGLE -->
      <td class="text-center">
        
      </td>
      </tr>
    </tbody>
  </table>
  </mat-tab>

  <mat-tab label="{{'Other' | translate | async}}">
    <panel>
    <div class="center" *ngIf="loadingPreferences">
        <mat-spinner diameter="32"></mat-spinner>
    </div>
    <ul class="preferences" *ngIf="!loadingPreferences">
         <!-- <li>
            <preference [label]="'Alerts on the Dashboards' | translate | async" [description]="'When the box is ticked the alerts will show. ' | translate | async">
                <mat-checkbox [(ngModel)]="EnableDashboardAlerts" (click)="updateDashBoardAlertStatus($event.target)"></mat-checkbox>
            </preference>
           
        </li> -->
        <!-- <li>
            <preference [label]="'Undercarriage Inspections Due Emails' | translate | async" [description]="'Determines whether the sending of Inspections Due Emails is enabled or disabled. ' | translate | async">
                <mat-checkbox [(ngModel)]="InspectionsDueEmails" (click)="updateInspectionsDueEmail($event.target)"></mat-checkbox>
            </preference>

           
        </li> -->
        <li>
            <preference [label]="'Daily Inspections Due Emails' | translate | async" [description]="'Alerting a user of any overdue Digital Inspections which have not been completed after 40 hours. ' | translate | async">
                <mat-checkbox [(ngModel)]="DailyInspectionsDueEmails" (click)="updateDailyInspectionsDueEmail($event.target)"></mat-checkbox>
            </preference>
        </li>

        <!-- <li>
            <preference [label]="'PIP Emails' | translate | async" [description]="'Receive email alerts for PIP’s  ' | translate | async">
                <mat-checkbox [(ngModel)]="EnablePIPEmails" (click)="UpdateEnablePIPEmails($event.target)"></mat-checkbox>
            </preference>
        </li> -->

        <li *ngIf="isSupervisor==true">
            <preference [label]="'DFI Emails' | translate | async" [description]="'Receive email alerts for DFI’s  ' | translate | async">
                <mat-checkbox [(ngModel)]="EnableDFIEmails" (click)="UpdateEnableDFIEmails($event.target)"></mat-checkbox>
            </preference>
        </li>
        <!-- <li>
            <preference [label]="'Leave Approval Emails' | translate | async" [description]="'Receive email alerts to approve leave requests-QLD' | translate | async" [description]="'NSW' | translate | async">
                <br/>
                <mat-checkbox [(ngModel)]="EnableQLDEmails" (click)="UpdateEnableQLDEmails($event.target)"></mat-checkbox>
                <br/>
                <span style="margin-left: -60px;padding-right: 15px;top: 2px;position: relative;color: #828282;">- NSW  </span><mat-checkbox [(ngModel)]="EnableNSWEmails" (click)="UpdateEnableNSWEmails($event.target)"></mat-checkbox>
                <br/>
                <span style="margin-left: -52px;padding-right: 18px;color: #828282;">- WA   </span><mat-checkbox [(ngModel)]="EnableWAEmails" (click)="UpdateEnableWAEmails($event.target)"></mat-checkbox>
            </preference>
        </li> -->
    </ul>
</panel>
  </mat-tab>

</mat-tab-group>
<!-- <div class="custom-checkbox">
   <mat-checkbox [(ngModel)]="EnableDashboardAlerts" (click)="updateDashBoardAlertStatus($event.target)"> {{'Alert Bell on the Dashboards' | translate | async}}</mat-checkbox>
  </div> -->

</div>  
